var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import withRouter from '../hoc/withRouter';
import { observer } from 'mobx-react';
import { computed, extendObservable } from 'mobx';
import { areRoutesEqual } from 'mobx-little-router';
import { OutletType } from '../propTypes';
import TransitionGroup from './TransitionGroup';
/*
 * Outlet component is responsible for rendering the matched components
 * from RouterStore into it. Each Outlet element renders it's current node index
 * in the path, and then provides the next index to subsequent Outlet components.
 */

var Outlet = function (_Component) {
  _inherits(Outlet, _Component);

  function Outlet(props, context) {
    _classCallCheck(this, Outlet);

    var _this = _possibleConstructorReturn(this, (Outlet.__proto__ || Object.getPrototypeOf(Outlet)).call(this, props, context));

    var _this$props = _this.props,
        router = _this$props.router,
        name = _this$props.name;

    var idx = _this.getCurrentIndex();

    extendObservable(_this, {
      currRoutes: computed(function () {
        return filterRoutes(router._store.routes);
      }),
      prevRoutes: computed(function () {
        return filterRoutes(router._store.prevRoutes);
      }),
      to: computed(function () {
        return findRoute(_this.currRoutes, idx, name);
      }),
      from: computed(function () {
        return findRoute(_this.prevRoutes, idx, name);
      }),
      isTransitioning: computed(function () {
        return _this.prevRoutes.length > 0 && !areRoutesEqual(_this.to, _this.from) && (canTransition(_this.to) || canTransition(_this.from));
      })
    });
    return _this;
  }

  _createClass(Outlet, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        outlet: {
          currentIndex: this.getCurrentIndex() + 1
        }
      };
    }
  }, {
    key: 'getCurrentIndex',
    value: function getCurrentIndex() {
      return typeof this.context.outlet !== 'undefined' ? this.context.outlet.currentIndex : 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          router = _props.router,
          name = _props.name,
          rest = _objectWithoutProperties(_props, ['router', 'name']);

      var idx = this.getCurrentIndex();
      var dataProps = {
        'data-depth': idx,
        'data-name': name
      };
      return React.createElement('div', _extends({
        className: 'outlet'
      }, dataProps), React.createElement(TransitionGroup, {
        to: this.to,
        from: this.isTransitioning ? this.from : undefined,
        isTransitioning: this.isTransitioning,
        additionalProps: rest
      }));
    }
  }]);

  return Outlet;
}(Component);

Outlet.contextTypes = {
  // We may have another outlet above us in the context.
  outlet: OutletType
};
Outlet.childContextTypes = {
  outlet: OutletType
};

var filterRoutes = function filterRoutes(routes) {
  return routes.filter(function (route) {
    return route.data.component;
  });
};

var findRoute = function findRoute(routes, outletIdx, outletName) {
  if (typeof outletName === 'string') {
    return routes.slice().reverse().find(function (route) {
      return route.data.outlet === outletName;
    });
  } else {
    return routes.filter(function (route) {
      return !route.data.outlet;
    })[outletIdx];
  }
};

var canTransition = function canTransition(node) {
  return node ? typeof node.onTransition === 'function' : false;
};

export default withRouter(observer(Outlet));